import {UserManagementType} from "../../interfaces/User";

export const defaultProfile = {
    "userEditableFields":[],
    "email":"",
    "firstName":"",
    "lastName":"",
    "userName":"",
    "displayName":"",
    "jobRole":"",
    "profilePictureUrl":"/img/general/no_profile_picture@2x.png",
    "id":0,
    "profileEnabled":false,
    "displayNameSet":false,
    "profileEmail":"",
    "profilePhoneNumber":"",
    "department":"",
    "profilePicture":"",
    "isActive":false,
    "userManagementType": UserManagementType.LOCAL
}